import image1 from './341675610_3075286262775926_1037250746371991566_n.jpg';
import image2 from './343108918_1249723069254996_1508725202135451233_n.jpg';
import image3 from './341574772_255036097005315_9170128328932906310_n.jpg';

const people = [
  {
    name: 'Jan Rembikowski',
    email: 'jan.remb@gmail.com',
    phone: '123-456-789',
    linkedin: 'https://www.linkedin.com/in/jan-rembikowski/',
    github: 'https://github.com/joohnnyvv',
    img: image1
  },
  {
    name: 'Arkadiusz Mądry',
    email: 'ark.madr@gmail.com',
    phone: '123-456-789',
    linkedin: 'https://www.linkedin.com/in/arkadiusz-madry/',
    github: 'https://github.com/arix2000',
    img: image2
  },
  {
    name: 'Maciej Kiełducki',
    email: 'mac.kiel@gmail.com',
    phone: '123-456-789',
    linkedin: 'https://www.linkedin.com/in/maciej-kiełducki/',
    github: 'https://github.com/maciekkielducki',
    img: image3
  },
];

export default people;
